import { Button, Container, Heading, Input, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom';

const ResetPassword = () => {
    const [password,setPassword]=useState();
    const params = useParams();
  return (
    <Container h={'90vh'} py={'16'}>
        <form>
            <Heading children="Reset Password" my='16' textAlign={['center','left']}/>
            <VStack spacing={'8'}>
                <Input required id='password' value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='*******' type='password' focusBorderColor='yellow.500' />
                <Button type='submit' w={'full'} colorScheme='yellow'>Reset Password</Button>
            </VStack>
        </form>
    </Container>
  )
}

export default ResetPassword